




















import _ from 'lodash'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop } from 'vue-property-decorator'

import { PluginMixin } from '@spa/mixins/plugin'
import { InfoService } from '@spa/services/api/info'

@Component
export default class AuthHeader extends Mixins<PluginMixin>(PluginMixin) {
  @Prop({ default: '' })
  title: string

  versioning: string | null = null

  shouldDisplayVersioning: boolean = false

  async created() {
    const [fetchVersionResult] = await Promise.all([
      InfoService.versioning(),
      this.$store.dispatch('history/setUrlToContinueShopping'),
    ])

    // TODO: Use Vuex store
    if (fetchVersionResult.isRight()) {
      this.versioning = _.get(fetchVersionResult.value, 'fullText')
      this.shouldDisplayVersioning = _.get(fetchVersionResult.value, 'display')
    }
  }

  /**
   * 他のタイプのヘッダーではトップのURLはpagesレイヤーで決定してヘッダーにpropで渡しているが、AuthHeaderは文脈が明確であり、
   * ページによってトップのURLの算出ロジックを切り替えたいということは多くないだろうと考え、AuthHeader側に実装している。
   *
   * TODO: おそらくhistory/topUrlに不具合（or環境変数の設定漏れ？）があり、MCでも常に `/` が返ってきていそう
   * これはhistory/topUrlの修正が必要という方向に倒し、いったんはhistory/topUrlで正しくコンテキストを考慮した「TOPページ」のURLが返ってくることを前提に実装する
   * （さしあたってホテラバでは常に `/` でも問題にならないので）
   * @see https://github.com/Everforth/growthpalette-front/issues/8253
   * @see https://github.com/Everforth/growthpalette-front/issues/8255
   */
  get topUrl(): string {
    return this.$store.getters['history/topUrl'] || '/'
  }
}
